import React from 'react'
import { TimeColumnKey, TimeKind, timeValue } from './columns'
import { t } from '../../../i18n'
import { OrderRow, EMPTY_PLACEHOLDER } from '../types'

const scope = 'orders.time_labels'

const TimeStackCell = ({
  row,
  column,
  kinds
}: {
  row: OrderRow
  column: TimeColumnKey
  kinds: TimeKind[]
}) => (
  <td className="time-stack">
    {kinds.map((kind) => (
      <div
        key={kind}
        className={`time-stack__line time-stack__line--${kind}`}
        title={t(kind, { scope })}
      >
        {timeValue(row, column, kind) || EMPTY_PLACEHOLDER}
      </div>
    ))}
  </td>
)

export default TimeStackCell
